import { render, staticRenderFns } from "./regisInfoStudent.vue?vue&type=template&id=6a570788"
import script from "./regisInfoStudent.vue?vue&type=script&lang=js"
export * from "./regisInfoStudent.vue?vue&type=script&lang=js"
import style0 from "./regisInfoStudent.vue?vue&type=style&index=0&id=6a570788&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports